import * as React from "react";
import { DecorateEditorialHtml } from "src/components/flexComponents/Editorial/ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const CONTENT_ID_COUNT = 4;
export const CardComparisonNoFeeBenefitsEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [noFeeBenefits3xIcon, noFeeBenefits3xContent, noFeeBenefits1xIcon, noFeeBenefits1xContent] = React.useMemo(
    () => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />),
    []
  );

  return (
    <UitkSpacing
      padding={{ medium: { inline: "twelve" }, large: { inline: "unset", inlinestart: "twelve" } }}
      margin={{ medium: { inline: "twelve" }, large: { inline: "unset", inlinestart: "six" } }}
    >
      <div>
        <UitkLayoutGrid>
          <UitkLayoutGridItem>
            <UitkLayoutFlex space="three" alignItems="center">
              <UitkLayoutFlexItem>
                <div>{noFeeBenefits3xIcon}</div>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <div>
                  <UitkText size={400} weight="bold" align="left">
                    <div>{noFeeBenefits3xContent}</div>
                  </UitkText>
                </div>
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
          </UitkLayoutGridItem>
          <UitkSpacing padding={{ blockstart: "two" }}>
            <UitkLayoutGridItem>
              <UitkLayoutFlex space="three" alignItems="center">
                <UitkLayoutFlexItem>
                  <div>{noFeeBenefits1xIcon}</div>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <div>
                    <UitkText size={400} weight="bold" align="left">
                      <div>{noFeeBenefits1xContent}</div>
                    </UitkText>
                  </div>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutGridItem>
          </UitkSpacing>
        </UitkLayoutGrid>
      </div>
    </UitkSpacing>
  );
};

export default CardComparisonNoFeeBenefitsEditorial;
